import { KeplerGlLayers } from '@carto/kepler.gl/layers'
import { IconInfoModalFactory } from '@carto/kepler.gl/layers'
import settings from 'settings'

export const SVG_ICON_URL = `${settings.publicUrl}/builder/svg-icons.json`

function flatterIconPositions(icon) {
  // had to flip y, since @luma modal has changed
  return icon.mesh.cells.reduce((prev, cell) => {
    cell.forEach((p) => {
      prev.push(...[icon.mesh.positions[p][0], -icon.mesh.positions[p][1], icon.mesh.positions[p][2]])
    })
    return prev
  }, [])
}

export default class IconLayer extends KeplerGlLayers.IconLayer {
  getSvgIcons() {
    const fetchConfig = {
      method: 'GET',
      mode: 'cors' as RequestMode,
      cache: 'no-cache' as RequestCache
    }

    if (window.fetch) {
      window
        .fetch(SVG_ICON_URL, fetchConfig)
        .then((response) => response.json())
        .then((parsed = {}) => {
          const { svgIcons = [] } = parsed
          this.iconGeometry = svgIcons.reduce(
            (accu, curr) => ({
              ...accu,
              [curr.id]: flatterIconPositions(curr)
            }),
            {}
          )

          this._layerInfoModal = IconInfoModalFactory(svgIcons)
        })
    }
  }
}
